export default "__VITE_ASSET__53dff90d__"